import React, { Component } from 'react'
import { Link, Redirect } from 'react-router-dom'
import Button from '@material-ui/core/Button'
import Container from "@material-ui/core/Container"
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { isLoggedIn } from "../helpers/auth";





export default class Home extends Component {

    render() {
        if (isLoggedIn()) {
            return (<Redirect to="/chat" />)
        } else {
            return (
                <Container maxWidth="lg">
                    <Box my={10}>
                        <Grid
                            container
                            spacing={1}
                            direction="row"
                            justify="center"
                            alignItems="center"
                            alignContent="center"
                            wrap="nowrap"
                        >
                            <Typography variant="h2" color="primary">
                                Welcome to The Real Chatty 101
                            </Typography>
                        </Grid>
                    </Box>
                    <Box my={5}>
                        <Grid
                            container
                            spacing={1}
                            direction="row"
                            justify="center"
                            alignItems="center"
                            alignContent="center"
                            wrap="nowrap"
                        >
                            <Button variant="contained" color="secondary" size="large" component={Link} to={"/login"}>
                                Login
                            </Button>
                        </Grid>
                    </Box>
                </Container>
            )
        }
    }
}
